<footer>
    <div class="footer-div" fxLayout="column wrap" fxFlex="100">

        <div class="logo-div" fxLayout="row wrap" fxLayoutAlign="center">
            <span class="cinejoy-logo">cinejoy </span>
            <span class="creatics-logo"> |CREATICS</span>
        </div>

        <div class="details-div" fxLayout="column wrap" fxLayoutGap="15px grid" fxLayoutAlign="end center" >
            <div fxLayout="row wrap"  fxLayoutGap="30px">
                <a href="https://www.instagram.com/creaticsorg"><i class="fa fa-instagram fa-3x" aria-hidden="true"></i></a>
                <a href="https://www.facebook.com/CreaticsEnterprises"><i class="fa fa-facebook fa-3x" aria-hidden="true"></i></a>
                <a href="https://twitter.com/Creatics2"><i class="fa fa-twitter fa-3x" aria-hidden="true"></i></a>
            </div>
                <div class="creatics-details" fxLayout="column">
                    <p class="creatics-title">
                        {{header?.description}}
                    </p>
                    <p class="creatics-contact">
                        <ng-container *ngFor="let item of footerList; first as isFirst; last as isLast">
                            <a [href]="item.link">{{item.section}} </a> <ng-container >&nbsp; |
                                 </ng-container>
                        </ng-container>
                        <ng-container >
                            <ng-container *ngIf="footerList?.length <= 0"> &nbsp; |
                                 </ng-container> <a href="mailto:cinejoycustomers@cinequest.org">Contact Us</a>
                        </ng-container>
                    </p>
                    <p class="creatics-footer">
                        © {{copyright}}
                    </p>
                </div>

            </div>
        </div>

</footer>